import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const Apparatix = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{indigo.50}',
      100: '{indigo.100}',
      200: '{indigo.200}',
      300: '{indigo.300}',
      400: '{indigo.400}',
      500: '{indigo.500}',
      600: '{indigo.600}',
      700: '{indigo.700}',
      800: '{indigo.800}',
      900: '{indigo.900}',
      950: '{indigo.950}',
    },
  },
  components: {
    inputtext: {
      // !important needed on placeholder color because freaking Keeper browser extension overrides placeholder color
      css: () => `
        .p-inputtext {
          line-height: normal;
        }
        .p-inputtext::placeholder {
          color: var(--p-inputtext-placeholder-color) !important;
        }
      `,
    },
    overlaybadge: {
      root: {
        outline: {
          width: '1px',
        },
      },
    },
    tabs: {
      tabpanel: {
        padding: '0.875rem 0 1.25rem 0',
      },
      css: () => `
        .p-tablist-ddmenu .p-tab {
          font-size: 0.875rem;
          line-height: 1;
        }
      `,
    },
    togglebutton: {
      content: {
        borderRadius: '0.375rem',
      },
      css: () => `
        .p-togglebutton {
          line-height: normal;
        }
      `,
    },
    datatable: {
      css: () => `
        .no-left-padding .p-datatable-tbody > tr > td:first-child,
        .no-left-padding .p-datatable-thead > tr > th:first-child {
          padding-left: 0;
        }
      `,
    },
    multiselect: {
      css: () => `
        .p-multiselect-label {
          line-height: normal;
        }
      `,
    },
    select: {
      css: () => `
        .p-select-label {
          line-height: normal;
        }
      `,
    },
    splitbutton: {
      css: ({ dt }) => `
        .p-splitbutton-ai > .p-button-secondary {
          background: ${dt('ai.secondary.background')};
          border-color: transparent;
        }
        .p-splitbutton-ai:hover > .p-button-secondary:hover {
          background: ${dt('ai.secondary.hover.background')};
        }
        .p-splitbutton-ai:active > .p-button-secondary:active {
          background: ${dt('ai.secondary.active.background')};
        }
      `,
    },
    toast: {
      css: () => `
        .p-toast {
          max-width: 95vw;
        }
      `,
    },
  },
  extend: {
    ai: {
      primary: {
        background: 'var(--ai-primary-background) padding-box, linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)) border-box',
        hoverBackground: 'var(--ai-primary-background-hover) padding-box, linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)) border-box',
        activeBackground: 'var(--ai-primary-background-active) padding-box, linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)) border-box',
        borderColor: 'transparent',
        activeBorderColor: 'transparent',
        hoverBorderColor: 'transparent',
      },
      secondary: {
        background: 'linear-gradient(white, white) padding-box, var(--ai-border-gradient) border-box',
        hoverBackground: 'var(--ai-secondary-background-hover) padding-box, var(--ai-border-gradient) border-box',
        activeBackground: 'var(--ai-secondary-background-active) padding-box, var(--ai-border-gradient) border-box',
        borderColor: 'transparent',
        hoverBorderColor: 'transparent',
        activeBorderColor: 'transparent',
      },
    },
  },
});
